export default __webpack_public_path__ + "static/media/slider-right.01a3c763.svg";